/** What Cai is doing with the last answer; the line's height is kept either way, so nothing below it moves. */
export function ChatStatusLine({ text }: { text?: string }) {
  return (
    <div
      aria-live="polite"
      className="text-ink-400 pointer-events-none flex h-10 shrink-0 items-center justify-end px-4 text-xs"
    >
      {text && (
        <span
          key={text}
          className="animate-in fade-in slide-in-from-bottom-1 duration-700 motion-reduce:animate-none"
        >
          {text}
        </span>
      )}
    </div>
  )
}
